/**
 * Per-staff tax maths, mirroring StaffManagementController::applyTax() in PHP.
 *
 * The backend is always the authority - what it returns is what gets stored and
 * paid. This exists only so the Create Payroll screen can preview the split
 * before the request is sent, and it MUST stay in step with the PHP:
 *
 *   - a percentage is clamped to 100
 *   - a fixed tax never exceeds the gross
 *   - negative gross is never taxed
 *   - net is derived from the rounded gross and tax, so gross === tax + net
 */
const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

export function applyTax(taxType, taxRate, grossAmount) {
  let gross = Number(grossAmount);
  if (!Number.isFinite(gross)) gross = 0;
  gross = round2(gross);

  const type = String(taxType || '').toLowerCase();
  let rate = Number(taxRate);
  if (!Number.isFinite(rate)) rate = 0;

  const configured = (type === 'percentage' || type === 'fixed') && rate > 0;
  if (!configured || gross <= 0) {
    return { gross, tax: 0, net: gross, taxType: null, taxRate: 0 };
  }

  if (type === 'percentage') rate = Math.min(rate, 100);

  const tax = round2(Math.min(type === 'percentage' ? gross * (rate / 100) : rate, gross));

  return { gross, tax, net: round2(gross - tax), taxType: type, taxRate: round2(rate) };
}
